__webpack_require__.p = "//www.narscosmetics.com/on/demandware.static/-/Library-Sites-NARS-Shared-Library/en_US/v1723528465856/clp/2024/08-anniversary/";